module.exports = __webpack_public_path__ + "img/5.688d6857.jpg";